const firebase = require('firebase/app');
require('firebase/firestore');

const app = firebase.initializeApp({
        apiKey: "AIzaSyDdeeKVtQogHEmnu-nls6Z0lfH8UoLP64E",
        authDomain: "higher-lower-46f79.firebaseapp.com",
        databaseURL: "https://higher-lower-46f79.firebaseio.com",
        projectId: "higher-lower-46f79",
        storageBucket: "higher-lower-46f79.appspot.com",
        messagingSenderId: "242924418092",
    });

export const db = app.firestore();
export const highscoresCollection = db.collection('highscores');